import { useCallback, useEffect } from "react";
import { SIMULTANEOUS_ACCESS_CONTENT } from "../../../../consts/_simultaneosAccess";
import { getSavedDocument } from "../../../../services";
import AccessLimitLayout from "./components/_access-limit-layout";

import { useSearchParams } from "react-router-dom";

const SimultaneousAccessLimit = () => {
  const [searchParams] = useSearchParams();

  const fetchSavedItems = useCallback(async (pageNumber: number) => {
    try {
      await getSavedDocument({
        type: "",
        page: pageNumber,
        limit: 1,
      });
    } catch {}
  }, []);

  useEffect(() => {
    const validSession = searchParams.get("validSession");

    if (validSession === "true") {
      fetchSavedItems(1);
    }
  }, [searchParams, fetchSavedItems]);

  return (
    <AccessLimitLayout
      title={SIMULTANEOUS_ACCESS_CONTENT.GLOBAL_LIMIT_EXCEEDED.title}
      description={
        SIMULTANEOUS_ACCESS_CONTENT.GLOBAL_LIMIT_EXCEEDED.description
      }
    />
  );
};

export default SimultaneousAccessLimit;
